import { createSlice } from "@reduxjs/toolkit";
import updateCurrentPageAction from "../actions/currentPageActions";
import selectCurrentPageSelector from "../selectors/currentPageSelectors";

const getInitialState = () => {
    // -------------------------------------------------------------------------
    // TODO: There is an opportunity to add logic to skip Classification when we
    // know on load this page should be skipped
    // -------------------------------------------------------------------------
    const currentPage = 0;
    return currentPage;
};

export const slice = createSlice({
    name: "currentPage",
    initialState: getInitialState(),
    reducers: {
        updateCurrentPage: updateCurrentPageAction,
    },
});

// actions
export const { updateCurrentPage } = slice.actions;

// selectors

// Same as getCurrentPage
export const selectCurrentPage = (state) => selectCurrentPageSelector(state);

export default slice.reducer;
